import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 0;

const slice = createSlice({
  name: '$remainingTotal',
  initialState,
  reducers: {
    setRemainingTotal(state, action: PayloadAction<number>) {
      return action.payload;
    },
  },
});

export const { setRemainingTotal } = slice.actions;
export default slice.reducer;
